import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a42c30b2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card bg-light reports--section" }
const _hoisted_2 = { class: "card-header section-header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash" }, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "float-right text-muted mt-1 mb-1 mr-2" }
const _hoisted_6 = { class: "h4 mb-0" }
const _hoisted_7 = { class: "card-body" }

import { Report, Section } from '@/models';
import { computed, inject, provide, getCurrentInstance } from 'vue';
import { useStore } from 'vuex';
import ReportRoomType from "@/components/report/Type.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Section',
  props: {
    index: {},
    section: {}
  },
  setup(__props: any) {

const actProperty: any = inject('actProperty');
const roomIndex = inject<number>('roomIndex');
const instance = getCurrentInstance();

const props = __props;

provide('sectionIndex', props.index);

const store = useStore();

const reportsState = computed(() => store.state.reports);

const report = computed<Report>({
  get: () => reportsState.value.current,
  set: (data: Report) => {
    setReport(data);
  },
});

const removeFromRooms = async (payload: { roomIndex: number; sectionIndex: number }) => {
  await store.dispatch('reports/removeFromRooms', payload);
};

const setReport = async (report: Report) => {
  await store.dispatch('reports/setReport', report);
};

const remove = async () => {
  actProperty
    .confirmPrompt()
    .then(() =>
      removeFromRooms({
        roomIndex: roomIndex!,
        sectionIndex: props.index,
      })
    )
    .then(() => instance?.proxy?.$forceUpdate());
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (remove())),
        class: "btn btn-sm btn-outline-danger float-right"
      }, _hoisted_4),
      _createElementVNode("code", _hoisted_5, _toDisplayString(_ctx.section.slug), 1),
      _createElementVNode("h3", _hoisted_6, _toDisplayString(_ctx.section.name), 1)
    ]),
    _createElementVNode("div", _hoisted_7, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.section.types, (type, $index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: type._uuid
        }, [
          _createVNode(ReportRoomType, {
            type: type,
            index: $index
          }, null, 8, ["type", "index"])
        ]))
      }), 128))
    ])
  ]))
}
}

})